export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-simple-maps/node_modules/d3-geo-projection/src/noop.js
// module id = jG/d
// module chunks = 0